<div class="mb-5">
    <app-activity-banner></app-activity-banner>
</div>

<app-token-treemap></app-token-treemap>
